import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { SearchOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import { ConfigProvider, Tabs, Spin, Button } from 'antd'
import OrderItem from './components/OrderItem'
import useModel from './useModel'
import { OrderStatusEnum, PlatformEnum } from '@/service/api/types'
import { preFixImgUrl } from '@/utils'

const Orders = () => {
  const { t } = useTranslation();
  const { orders, loading, activeStatus, setActiveStatus, activeKey, currentPage, pagination,onPreviousPage, setActiveKey, keyword, setKeyword, handSearch, onNextPage } = useModel();

  const statusOptions = useMemo(() => [{
    labelKey: 'ae49159d',
    value: OrderStatusEnum.ALL
  }, {
    value: OrderStatusEnum.PROCESSING,
    labelKey: 'e40e29b3',
  }, {
    labelKey: '9999b785',
    value: OrderStatusEnum.COMPLETED
  }, {
    labelKey: '4aaa5de9',
    value: OrderStatusEnum.CANCELLED
  }], [])

  return (
    <div className='w-8xl px-10 mx-auto leading-[1.5]'>
      <div className='flex justify-between items-center h-[108px] pt-4'>
        <LangText lngKey='220d4611' className='text-[30px] font-bold'>{t('220d4611')}</LangText>
        <div className='h-11 w-[514px] outline-2 outline-[#4B51FF] rounded-[22px] bg-white flex items-center'>
          <SearchOutlined className='text-[24px] !text-[#999999] ml-4 mr-4' />
          <input className='flex-1 focus:outline-none' placeholder={t('bf9c28b5')} value={keyword} onKeyDown={(e) => e.key === 'Enter' && handSearch()} onChange={(e) => setKeyword(e.target.value)} />
          <div className='h-[46px] px-6 rounded-[22px] bg-linear-to-r from-[#4B51FF] to-[#A75AFF] -mr-[2px] z-10 cursor-pointer' onClick={handSearch}>
            <LangText lngKey='25242fc9' className='text-white leading-[48px]'>{t('25242fc9')}</LangText>
          </div>
        </div>
      </div>
      <div className='w-full bg-white min-h-[500px] mb-6 rounded-[8px]'>
        <div className='px-5'>
          <ConfigProvider
            theme={{
              components: {
                Tabs: {
                  itemActiveColor: '#4B51FF',
                  itemHoverColor: '#4B51FF',
                  itemSelectedColor: '#4B51FF',
                  inkBarColor: '#4B51FF',
                },
              },
            }}
          >
            <Tabs
              size='large'
              activeKey={activeKey}
              onChange={(key) => setActiveKey(key as PlatformEnum)}
              className='px-5'
              items={[{
                label: t('470f02b5'),
                key: PlatformEnum.ALL,
              }, {
                label: t('6e124369'),
                key: PlatformEnum.JAPANMALL,
              }, {
                label: t('27be28e9'),
                key: PlatformEnum.SGW,
              }, {
                label: t('62d6dd78'),
                key: PlatformEnum.VIP,
              }]}
            />
          </ConfigProvider>
        </div>
        <div className='flex px-5'>
          {
            statusOptions.map((item) => (
              <div key={item.value} className={classNames('flex leading-[27px] cursor-pointer px-4', activeStatus === item.value && 'outline outline-[#4B51FF] rounded-[14px] ')} onClick={() => setActiveStatus(item.value)}>
                <LangText lngKey={item.labelKey} className={classNames('text-[14px]', activeStatus === item.value ? 'text-[#4B51FF]' : 'text-[#666666]')}>{t(item.labelKey)}</LangText>
              </div>
            ))
          }
        </div>
        <Spin spinning={loading}>
          <div className='flex flex-col px-5 mt-4 gap-5 pb-6 min-h-[500px]'>
            {
              orders?.map((order) => (
                <OrderItem key={order.orderNo} order={order} />
              ))
            }
            {!loading && orders?.length === 0 && <div className='flex flex-col justify-center items-center h-[500px]'>
              <img src={preFixImgUrl('a96886e4b44ee4e0eb0daf1cafe56e12.png')} className='w-[140px] h-[140px]' />
              <LangText lngKey='099bddcc' className='text-[14px]'>{t('099bddcc')}</LangText>
            </div>}
          </div>
          {Boolean(orders?.length) && <div className='flex gap-4 justify-end items-center px-5 pb-6'>
            <Button disabled={currentPage === 1} onClick={onPreviousPage}><LeftOutlined /></Button>
            <Button disabled={!pagination?.hasMore} onClick={onNextPage}><RightOutlined /></Button>
          </div>}
        </Spin>
      </div>
    </div>
  )
}

export default Orders